import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { ModulesInfo } from "../constants/modules"

export const useGetAttachmentTypes = () => {
    const { selectedNetwork } = useNetworksStateContext()

    if (!selectedNetwork) {
        return {}
    }
    return Object.entries(ModulesInfo)
        .sort(([_a, a], [_b, b]) => a.order - b.order)
        .filter(([_, moduleInfo]) => {
            return selectedNetwork.modules.includes(moduleInfo.module)
        }).map(([key, _]) => key)
}